import { cn } from '@commenda/utils';
import * as SwitchPrimitives from '@radix-ui/react-switch';
import { cva, type VariantProps } from 'class-variance-authority';
import React from 'react';

const switchVariants = cva(
  'peer inline-flex shrink-0 cursor-pointer items-center rounded-full focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-fg-brand transition-colors focus-visible:outline-none disabled:cursor-not-allowed data-[state=checked]:bg-fg-brand hover:data-[state=checked]:bg-fg-brand-hover data-[state=unchecked]:bg-bg-tertiary disabled:data-[state=checked]:bg-bg-disabled disabled:data-[state=unchecked]:bg-bg-disabled',
  {
    variants: {
      size: {
        sm: 'h-5 w-9',
        md: 'h-6 w-11',
      },
    },
    defaultVariants: {
      size: 'sm',
    },
  }
);

const thumbVariants = cva(
  'pointer-events-none block rounded-full bg-fg-white shadow-sm ring-0 transition-transform',
  {
    variants: {
      size: {
        sm: 'h-4 w-4 data-[state=unchecked]:translate-x-0.5 data-[state=checked]:translate-x-[18px]',
        md: 'h-5 w-5 data-[state=unchecked]:translate-x-0.5 data-[state=checked]:translate-x-[22px]',
      },
    },
    defaultVariants: {
      size: 'sm',
    },
  }
);

interface SwitchProps
  extends React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>,
    VariantProps<typeof switchVariants> {}

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  SwitchProps
>(({ className, size, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(switchVariants({ size, className }))}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb className={cn(thumbVariants({ size }))} />
  </SwitchPrimitives.Root>
));

Switch.displayName = SwitchPrimitives.Root.displayName;

export default Switch;
